import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { getConstants } from "../actions/constantActions";
import Spinner from '../components/Spinner';

// Hide all children components until initialization procedure is finished
class Initialization extends Component {

  componentDidMount() {
    const { ready } = this.props;
    if (!ready) {
      this.initialize();
    }
  }

  initialize() {
    const { dispatch } = this.props;
    dispatch(getConstants());
  }

  render() {
    const { ready } = this.props;
    if (ready) {
      return this.props.children;
    }

    return <Spinner text='Initializing' />
  }
}

const mapStateToProps = state => {
  const { constantRequest } = state;

  const ready = !isEmpty(constantRequest.constants);

  return { ready };
};

export default connect(mapStateToProps)(Initialization);
